import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints,
}: Theme) => ({
  root: {
    margin: '1rem 0',
    [breakpoints.up('md')]: {
      margin: '1.25rem 0',
    },
  },
}));
